export const audioFeatures = ['base', 'peaks', 'beats', 'onsets', 'chroma', 'chords', 'power'] as const
export type AudioFeatureType = (typeof audioFeatures)[number]
